import { InterleavedBufferAttribute } from '../../thirdparty/three/imports';

export class InterleavedBufferAttribute3D
{
    _bufferAttribute: InterleavedBufferAttribute;

    get array()
    {
        return this._bufferAttribute.array as number[];
    }

    get count()
    {
        return this._bufferAttribute.count;
    }

    static get(bufferAttribute: InterleavedBufferAttribute)
    {
        let bufferAttribute3d = this._map.get(bufferAttribute);
        if (!bufferAttribute3d)
        {
            bufferAttribute3d = new InterleavedBufferAttribute3D();
            bufferAttribute3d._bufferAttribute = bufferAttribute;
            InterleavedBufferAttribute3D._map.set(bufferAttribute, bufferAttribute3d);
        }

        return bufferAttribute3d;
    }
    private static _map = new Map<InterleavedBufferAttribute, InterleavedBufferAttribute3D>();
}
